import { client } from '@/common/lib/fetch'
import type { AddCompetitionRequest, AddCompetitionResponse } from '@/common/types/api'
export type { AddCompetitionRequest, AddCompetitionResponse }

export const addCompetition = async (orgId: string, data: AddCompetitionRequest): Promise<AddCompetitionResponse> => {
    const response = await client.post<AddCompetitionResponse>(
        `/api/v1/generations/${orgId}/validate-product/competition`,
        data
    )
    return response.data
}
